import React__default, { useMemo } from 'react';
import { FilterDropdownWrapper } from '../../styles.js';
import CheckboxFilterDropdown from '../CheckboxFilterDropdown/index.js';
import SelectFilterDropdown from '../SelectFilterDropdown/index.js';
import SliderFilterDropdown from '../SliderFilterDropdown/index.js';
import { VertDivider } from './styles.js';

var FilterDropdown = function (_a) {
    var resetFilter = _a.resetFilter, filter = _a.filter, onChange = _a.onChange, separator = _a.separator, mobile = _a.mobile, prefixId = _a.prefixId;
    var Component = useMemo(function () {
        if (filter.type === "slider") {
            return SliderFilterDropdown;
        }
        else if (filter.type === "select") {
            return SelectFilterDropdown;
        }
        else if (filter.type === "checkbox") {
            return CheckboxFilterDropdown;
        }
        return null;
    }, [filter.type]);
    if (!Component)
        return null;
    return (React__default.createElement(FilterDropdownWrapper, { mobile: mobile },
        React__default.createElement(Component, { mobile: mobile, resetFilter: resetFilter, filter: filter, onChange: onChange, prefixId: prefixId }),
        separator && React__default.createElement(VertDivider, { orientation: "vertical", flexItem: true })));
};

export { FilterDropdown as default };
